import type { Vault } from '@/types/vault'

export function isVaultTokenInTokens(vault: Vault, tokens: Vault['asset']['symbol'][]): boolean {
  if (tokens.length === 0) return true
  return tokens.includes(vault.asset.symbol)
}
